<style scoped>
::v-deep .custom-checkbox .v-icon {
  font-size: 18px;
}

::v-deep .custom-checkbox .v-label {
  font-size: 14px;
}
</style>

<style>
.v-tooltip__content.cp-arrow-tooltip {
  position: absolute;
  overflow: visible !important;
  background-color: #000 !important;
  color: #fff !important;
  opacity: 1 !important;
  border-radius: 4px;
  padding: 6px 10px;
}

.v-tooltip__content.cp-arrow-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid transparent;
  border-bottom-color: #000;
}
</style>
<template>
  <v-form ref="form">
    <div>
      <v-breadcrumbs :items="getBreadcrumb" large class="pa-0">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
      <v-row>
        <v-col>
          <v-card class max-width="auto">
            <v-list-item class="subtitle-1" style="background-color: #2c95da; color: white">
              <v-list-item-content>
                <v-list-item-title class="body-1 white--text">Resource Log</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="company"
                    :items="getCompany"
                    label="Company"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="policy"
                    :items="companyPolicy"
                    item-text="policy_id"
                    item-value="policy_id"
                    label="Policy"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="From"
                        clearable
                        prepend-icon="far fa-calendar-alt"
                        readonly
                        v-on="on"
                        @click:clear="startDate = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      :show-current="show_current_date"
                      :min="startDateMin"
                      :max="startDateMax"
                      no-title
                      scrollable
                      @input="menuStartDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3">
                  <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDate"
                        clearable
                        label="To"
                        prepend-icon="far fa-calendar-alt"
                        readonly
                        v-on="on"
                        @click:clear="endDate = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      :show-current="show_current_date"
                      :min="endDateMin"
                      :max="todayDate"
                      no-title
                      scrollable
                      @input="menuEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" style="justify-content: end; display: flex; align-items: center">
                  <v-btn class="ma-1" color="info" @click="handleClick" :disabled="buttonDisable || isLoading"
                    >Filter</v-btn
                  >
                  <v-btn
                    class="ma-1"
                    color="success"
                    @click="handleExport"
                    :disabled="buttonDisable || isLoading || !isExport"
                    ><v-icon left>fas fa-file-excel</v-icon> Export</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" style="justify-content: end; display: flex; align-items: center">
                  <v-tooltip bottom content-class="cp-arrow-tooltip" :disabled="buttonDisable || isLoading">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-inline-block">
                        <v-checkbox
                          v-model="checkOldLogs"
                          :disabled="buttonDisable || isLoading"
                          color="black"
                          hide-details
                          dense
                          class="custom-checkbox mt-0 pt-0"
                        >
                          <template v-slot:label>
                            <span class="custom-label-text">Display Old Logs</span>
                            <v-icon size="13px" class="ml-1 custom-icon">fa-info-circle</v-icon>
                          </template>
                        </v-checkbox>
                      </div>
                    </template>
                    <span>Display old logs update prior to {{ lastDayDisplayLogs }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div>
        <v-text-field color="primary" loading disabled v-if="isLoading"></v-text-field>
      </div>
      <div v-if="!isLoading">
        <v-row v-if="isResourceLog">
          <v-col cols="7" md="7">
            <PolicyDocumentsLog
              :items="getResourceLog.policyDocuments"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Policy Documents"
            ></PolicyDocumentsLog>
          </v-col>
          <v-col cols="5" md="5">
            <PolicyDocumentUrlsLog
              :items="getResourceLog.policyUrl"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Policy URLs"
            ></PolicyDocumentUrlsLog
          ></v-col>
        </v-row>
        <v-row>
          <v-col
            cols="7"
            md="7"
            v-if="getResourceLog.policySubgroupFile && getResourceLog.policySubgroupFile.length > 0"
          >
            <PolicySubgroupDocumentsLog
              :items="getResourceLog.policySubgroupFile"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Policy SubGroup Documents"
            ></PolicySubgroupDocumentsLog>
          </v-col>
          <v-col cols="5" md="5" v-if="getResourceLog.policySubgroupUrl && getResourceLog.policySubgroupUrl.length > 0">
            <!-- <PolicyDocumentUrlsLog
              :items="getResourceLog.policySubgroupUrl"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Policy SubGroup URLs"
            ></PolicyDocumentUrlsLog> -->
            <PolicySubgroupDocumentUrlsLog
              :items="getResourceLog.policySubgroupUrl"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Policy SubGroup URLs"
            ></PolicySubgroupDocumentUrlsLog>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="7"
            md="7"
            v-if="getResourceLog.lifePolicySubGroupFile && getResourceLog.lifePolicySubGroupFile.length > 0"
          >
            <PolicySubgroupDocumentsLog
              :items="getResourceLog.lifePolicySubGroupFile"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Life Policy SubGroup Documents"
            ></PolicySubgroupDocumentsLog>
          </v-col>
          <v-col
            cols="5"
            md="5"
            v-if="getResourceLog.lifePolicySubgroupUrl && getResourceLog.lifePolicySubgroupUrl.length > 0"
          >
            <PolicyDocumentUrlsLog
              :items="getResourceLog.lifePolicySubgroupUrl"
              :userViewed="getUserViewed"
              :loading="isUserViewedLoading"
              @getUsers="handleGetUsers"
              title="Life Policy SubGroup URLs"
            ></PolicyDocumentUrlsLog
          ></v-col>
        </v-row>
      </div>
    </div>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PolicyDocumentsLog from "../components/ResourceLog/PolicyDocumentsLog.vue";
import PolicyDocumentUrlsLog from "../components/ResourceLog/PolicyDocumentUrlsLog.vue";
import PolicySubgroupDocumentsLog from "../components/ResourceLog/PolicySubgroupDocumentsLog.vue";
import PolicySubgroupDocumentUrlsLog from "../components/ResourceLog/PolicySubgroupDocumentUrlsLog.vue";
import { getLastDayOfDisplayLogs } from "../utils/utils.js";

const MEDICAL_POLICY = "MedicalPolicy";
const SEC_BENEFIT_POLICY = "SecBenefitPolicy";

export default {
  name: "resource",
  components: {
    PolicyDocumentsLog: PolicyDocumentsLog,
    PolicyDocumentUrlsLog: PolicyDocumentUrlsLog,
    PolicySubgroupDocumentsLog: PolicySubgroupDocumentsLog,
    PolicySubgroupDocumentUrlsLog: PolicySubgroupDocumentUrlsLog
  },
  data() {
    return {
      company: "",
      companyPolicy: [],
      policy: "",
      startDate: "",
      endDate: "",
      show_current_date: false,
      menuStartDate: false,
      menuEndDate: false,
      todayDate: new Date().toISOString().slice(0, 10),
      startDateMin: "",
      startDateMax: "",
      endDateMin: "",
      isLoading: false,
      isExport: false,
      isUserViewedLoading: true,
      buttonDisable: true,
      checkOldLogs: false,
      appliedFilters: null,
      dateRules: [v => !!v || "Date is required"]
    };
  },
  computed: {
    ...mapGetters("Layout", ["getBreadcrumb", "getVersion"]),
    ...mapGetters("Resourcelog", ["getCompany", "getPolicy", "getPolicyType", "getResourceLog", "getUserViewed"]),
    isSecBenefit() {
      return this.getPolicyType === SEC_BENEFIT_POLICY;
    },
    isMedical() {
      return this.getPolicyType === MEDICAL_POLICY;
    },
    isResourceLog() {
      return [MEDICAL_POLICY, SEC_BENEFIT_POLICY].includes(this.getPolicyType);
    },
    lastDayDisplayLogs() {
      return getLastDayOfDisplayLogs();
    }
  },
  watch: {
    getVersion() {
      this.company = "";
      this.policy = "";
      this.startDate = "";
      this.endDate = "";
      this.appliedFilters = null;
      this.checkOldLogs = false;
      if (this.getPolicyType) {
        this.resetPolicyType();
      }

      this.$store.dispatch("Resourcelog/getCompanyAndPolicyData");
      this.$refs.form.resetValidation();
      this.startDateMax = this.todayDate;
    },
    getResourceLog(value) {
      this.isLoading = Object.keys(value).length > 0 && this.policy ? false : true;
      this.isExport = false;
      if (
        value &&
        (value.policyDocuments.length > 0 ||
          value.policySubgroupFile.length > 0 ||
          value.policySubgroupUrl.length > 0 ||
          value.policyUrl.length > 0)
      ) {
        this.isExport = true;
      }
    },
    getUserViewed(value) {
      this.isUserViewedLoading = false;
    },
    company(id) {
      this.companyPolicy = this.getPolicy.filter(item => item.company_id === id);

      this.buttonDisable = true;
    },
    policy() {
      this.buttonDisable = false;
    },
    startDate() {
      this.endDateMin = this.startDate;

      if ((this.startDate && this.endDate && this.policy) || (!this.startDate && !this.endDate && this.policy)) {
        this.buttonDisable = false;
      } else {
        this.buttonDisable = true;
      }
    },
    endDate() {
      this.buttonDisable = this.startDate && this.endDate && this.policy ? false : true;

      if ((this.startDate && this.endDate && this.policy) || (!this.startDate && !this.endDate && this.policy)) {
        this.buttonDisable = false;
      } else {
        this.buttonDisable = true;
      }

      if (this.endDate) this.startDateMax = this.endDate;
      else this.startDateMax = this.todayDate;
    }
  },
  methods: {
    ...mapMutations({
      resetPolicyType: "Resourcelog/RESET_POLICY_TYPE",
      resetResourceLog: "Resourcelog/RESET_RESOURCE_LOG"
    }),
    buildFilterParams() {
      return {
        startDate: this.startDate && new Date(this.startDate + " 00:00:01").toISOString(),
        endDate: this.endDate && new Date(this.endDate + " 23:59:59").toISOString(),
        policyId: this.policy,
        oldLog: this.checkOldLogs
      };
    },
    handleClick() {
      this.isLoading = true;
      this.appliedFilters = this.buildFilterParams(); // snapshot
      this.$store.dispatch("Resourcelog/getResorceLogData", { ...this.appliedFilters });
    },
    handleGetUsers(resource) {
      if (!this.appliedFilters) return;
      this.isUserViewedLoading = true;
      this.$store.dispatch("Resourcelog/getUserViewedData", {
        ...this.appliedFilters,
        section: resource.section,
        fileName: resource.fileName,
        subGroup: resource.subGroup,
        resourceId: resource.resourceId
      });
    },
    handleExport() {
      if (!this.isExport || !this.appliedFilters) return;
      this.$store.dispatch("Resourcelog/exportResourcesLogData", { ...this.appliedFilters });
    }
  },
  created() {
    this.$store.dispatch("Layout/SET_BREADCRUMB", "resource_log");
    this.$store.dispatch("Resourcelog/getCompanyAndPolicyData");
    this.startDateMax = this.todayDate;

    if (this.getPolicyType) {
      this.resetPolicyType();
    }
  }
};
</script>
